import styles from './CompactContainer.module.css'

export function CompactContainer({children}: {children: React.ReactNode}) {
  return (
    <div className={styles.container}>
      <div className={styles.comments}>{children}</div>
    </div>
  )
}
